import { memo } from 'react';
import { useIntl } from 'react-intl';

import { getRoute } from 'Config';

import ExploreIcon from 'Assets/reactSvgs/ExploreIcon';

import NavBarLinkBase from './NavBarLinkBase';

const navigationPayload = {
  sessionDestination: 'explore',
};

const RecsNavBarLink = () => {
  const { formatMessage } = useIntl();

  return (
    <NavBarLinkBase
      i13nModel={{ message: 'Explore' }}
      intlMessage={formatMessage({ id: 'explore' })}
      navigationPayload={navigationPayload}
      to={getRoute('explore')}
      data-testid="recsLink"
    >
      <ExploreIcon className="Sq(28px) navbarActive_C($c-ds-brand-primary) C($c-ds-icon-navigation-primary-inactive) Trsdu($fast)" />
    </NavBarLinkBase>
  );
};

export default memo(RecsNavBarLink);
